import * as React from 'react'

import Button from 'src/components/atoms/common/Button'
import Img from 'src/components/molecules/common/ResponsiveImage'

import * as styles from 'src/components/molecules/Modal/QuestionnaireRequest/Result/style.module.styl'

interface IProps {
  children?: React.ReactNode
  options?: {
    resultID?: string
    callback?: Function
  }
}

const Component: React.FC<IProps> = (props) => {
  const handleClick = (e) => {
    props.options?.resultID && navigator.clipboard && navigator.clipboard.writeText(props.options?.resultID)
  }

  return (
    <div className={styles.questionnairerequest}>
      <h2 className={styles.questionnairerequest_title}>
        <Img src="common/questionnairerequest/result_ttl_1.svg" alt="アンケートご協力のお願い" />
      </h2>
      <div className={styles.questionnairerequest_image}>
        <span className={styles.image}>
          <span className={styles.image_1}><Img src="common/questionnairerequest/img_1.svg" alt="" /></span>
          <span className={styles.image_2}><Img src="common/questionnairerequest/img_2.svg" alt="" /></span>
        </span>
      </div>
      <div className={styles.questionnairerequest_description}>
        <p>
          AI診断サービスをご利用いただき<br />
          ありがとうございます。<br />
          サービス品質向上のためアンケートに<br />
          ご協力をお願いいたします。
        </p>
        <p>
          アンケートにご協力いただいた方のうち<br />
          毎週50名さまへAmazonギフトカード1,000円分を<br />
          抽選でプレゼントしております
        </p>
      </div>
      {navigator.clipboard && props.options?.resultID && (
        <div className={styles.questionnairerequest_copyid}>
          <button
            className={styles.copyid}
            onClick={(e) => { handleClick && handleClick(e) }}
          >
            <span className={styles.copyid_icon}><i className={'cIcon-arrow1'} /></span>
            <span className={styles.copyid_text}>アンケートで使用するIDをコピーする</span>
          </button>
        </div>
      )}
      <div className={styles.questionnairerequest_buttons}>
        <ul className={styles.buttons}>
          <li className={styles.buttons_item}>
            <Button className="blank" url="https://csi.post-survey.com/bs_tire-ai_service_24aut/" tgt="_blank">アンケート回答は<br />こちらから</Button>
          </li>
        </ul>
      </div>
    </div>
  )
}
export default Component
